import { render, staticRenderFns } from "./iconArrow.vue?vue&type=template&id=ee5c15ac"
import script from "./iconArrow.vue?vue&type=script&lang=js"
export * from "./iconArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports